/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){return n?.25:1}export{n as getHeatmapCompressionFactor};
